import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Input from 'material-ui/Input';
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";
import styles from "./styles";
import { Translate } from "react-localize-redux";

const NodeNameModal = (props) => {
    const title = props.title;
    const isOpen = props.isOpen;
    const showHideNodeModal = props.showHideNodeModal;
    const classes = props.classes;
    const onNodeNameClose = props.onNodeNameClose;
    const translate = props.translate;
    const nodeType = props.nodeType;

    const closeNodeModal = () => showHideNodeModal(false);
    const [nodeName, setNodeName] = React.useState('');
    function onNodeNameChange(e) {
        setNodeName(e.target.value);
    }

    function saveNodeModal() {
        closeNodeModal();
        onNodeNameClose(nodeName);
    }

    let maxNameLength = 12;

    if (nodeType === 'job') {
        maxNameLength = 30;
    }

    return (
        <Modal open={isOpen}>
            <div className={classes.root}>
            <form noValidate autoComplete="off">
                <Paper className={classes.modal}>
                    <ModalHeader>
                        <Typography type="subheading" color="inherit" className={classes.flex}>
                            {title}
                        </Typography>
                        <Button className={classes.button} onClick={closeNodeModal}>
                            <Icon>clear</Icon>
                        </Button>
                    </ModalHeader>
                    <ModalContents>
                        <Input style={{width:'300px'}} type="text" autoFocus placeholder={translate("profile_name")} onChange={onNodeNameChange} value={nodeName} inputProps={{ maxLength: maxNameLength }} />
                    </ModalContents>
                    <ModalFooter classes={classes}>
                      <Button className={classes.submit} raised color="accent" type="submit" onClick={saveNodeModal} disabled={!nodeName || nodeName.length < 1}>
                          {translate("sub_set_ping_save_target")}
                      </Button>
                    </ModalFooter>
                </Paper>
                </form>
            </div>
        </Modal>
    );
};

export default withStyles(styles)(NodeNameModal);
